<template>
  <section class="feature">
    <div class="container">
      <a-typography-title :level="1">
        产品特点
      </a-typography-title>
      <a-row :gutter="[40,20]">
        <a-col v-for="item in expand.content"
               :xs="24" :lg="8">
          <div class="item">
            <a-typography-title :level="5">
              {{ item.title }}
            </a-typography-title>
            <a-typography-paragraph>
              {{ item.text }}
            </a-typography-paragraph>
          </div>
        </a-col>
      </a-row>
      <!--<a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">-->
      <!--    <a-button type="link" class="button_1"-->
      <!--              @click="$Store.Page().openModal('modalQR','tryUse')">-->
      <!--        立即体验-->
      <!--    </a-button>-->
      <!--</a-space>-->
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'product_feature',
  data(): DataInterface {
    return {
      expand: {
        content: [
          {
            title: '全流程',
            text: '贯穿成本管理全流程，从预算管理、容量管理，到洞察报告、优化策略、长期运营，省心又省时'
          },
          {
            title: '全场景',
            text: '适用于公有云、私有云、混合云的全场景解决方案；无论物理机、虚机、容器，还是存储、网络，均可通过本产品实现成本洞察与分析'
          },
          {
            title: '全方位',
            text: '从多种维度全面洞悉成本现状，并从业务架构、云服务选型、付费类型等多种角度提供全方位的优化建议'
          }
        ]
      }
    };
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/productCostPilot/';

.feature {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background-color: @color_9;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
  }
}


h1.ant-typography {
  position: relative;
  margin: 0;
  .font(center, @title, @color_12, @title, true);
  
  &::before {
    content: '';
    display: block;
    .position(bottom, -15px);
    width: 72px;
    height: 3px;
    margin: 0 auto;
    background-color: @color_6;
  }
}

.ant-row {
  margin: @margin 0 0;
  
  .ant-col {
    &:nth-child(1) {
      .item::before {
        .bg('@{image}icon_3_1.png', 110px, 106px);
      }
    }
    
    &:nth-child(2) {
      .item::before {
        .bg('@{image}icon_3_2.png', 108px, 110px);
      }
    }
    
    &:nth-child(3) {
      .item::before {
        .bg('@{image}icon_3_3.png', 110px, 110px);
      }
    }
    
    .item {
      position: relative;
      width: 100%;
      max-width: 375px;
      height: 320px;
      padding: 20px 30px;
      margin: 0 auto;
      background-color: @color_white;
      border-radius: 3px;
      .shadow(0 0 10px fade(@color_black, 10));
      
      &:hover {
        &::before {
          .transform(scale(1.1));
        }
      }
      
      &::before {
        content: '';
        display: block;
        width: 110px;
        max-width: 100%;
        height: 110px;
        margin: 0 auto;
        background-position: center !important;
        .transition(transform 1s);
      }
      
      h5.ant-typography {
        margin: 20px 0 0;
        .font(center, @text_big, @color_12, @text_big, true);
      }
      
      div.ant-typography {
        margin: @margin_mo 0 0;
        .font(justify, @text+@line, @color_3, @text);
        .wordBreak();
      }
    }
  }
}

.ant-space {
  margin-top: 50px;
  
  .button_1 {
    width: 320px !important;
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .feature {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo, @color_12, @title_mo, true);
    
    &::before {
      display: none;
    }
  }
  
  .ant-row {
    margin: @margin_mo 0 0;
    
    .ant-col {
      @scale: 0.5;
      
      &:nth-child(1) {
        .item::before {
          .bg('@{image}icon_3_1.png', 110px*@scale, 106px*@scale);
        }
      }
      
      &:nth-child(2) {
        .item::before {
          .bg('@{image}icon_3_2.png', 108px*@scale, 110px*@scale);
        }
      }
      
      &:nth-child(3) {
        .item::before {
          .bg('@{image}icon_3_3.png', 110px*@scale, 110px*@scale);
        }
      }
      
      .item {
        height: auto;
        
        &::before {
          width: 60px;
          height: 60px;
        }
        
        h5.ant-typography {
          margin: @margin_mo 0 0;
          .font(center, @text_big_mo, @color_12, @text_big_mo, true);
        }
        
        div.ant-typography {
          .font(justify, @text_mo+@line_mo, @color_3, @text_mo);
        }
      }
    }
  }
}
</style>